import { useRefinementList, type UseRefinementListProps } from "react-instantsearch";
import {useConfigContext} from "../../ConfigProvider.tsx";

type FilterCheckboxListProps = UseRefinementListProps & {
	title: string;
	searchEnabled?: boolean;
};

export function FilterCheckboxList(props: FilterCheckboxListProps) {
	const {
		items,
		refine,
		canToggleShowMore,
		isShowingMore,
		toggleShowMore,
		searchForItems,
	} = useRefinementList({
		...props,
	});
	const { tc } = useConfigContext();


	if (items.length === 0) {
		return null;
	}

	return (
		<div className="ais-filterCheckboxList">
			{props.searchEnabled && (
				<div className="inputGroup searchBar">
					<input
						type="search"
						autoCorrect="off"
						autoCapitalize="off"
						spellCheck={false}
						placeholder={`${props.title} durchsuchen …`}
						onChange={(event) => searchForItems(event.currentTarget.value)}
						autoComplete="off"
					/>
					<span className="inputGroup__addon">
						<i className="icon icon-search" aria-hidden={true}></i>
					</span>
				</div>
			)}

			<ul className="ais-filterCheckboxList__list">
				{items.map((item) => (
					<li key={item.label} className="ais-filterCheckboxList__item">
						<label
							htmlFor={item.label}
							className={`ais-filterCheckboxList__label ${
								item.isRefined ? "is-active" : ""
							}`}
						>
							<input
								id={item.label}
								className="ais-filterCheckboxList__checkbox"
								type="checkbox"
								checked={item.isRefined}
								onChange={() => refine(item.value)}
							/>
							<span className="custom-checkbox" aria-hidden></span>
							<span className="ais-filterCheckboxList__option">{item.label}</span>
						</label>
					</li>
				))}
			</ul>

			{canToggleShowMore && (
				<button
					type="button"
					onClick={toggleShowMore}
					className="ais-filterCheckboxList__showMoreButton"
				>
					{isShowingMore ? (
						<>
							<i className="icon icon-minus" aria-hidden={true}></i>
							<span>{tc.showLess}</span>
						</>
					) : (
						<>
							<i className="icon icon-plus" aria-hidden={true}></i>
							<span>{tc.showMore}</span>
						</>
					)}
				</button>
			)}
		</div>
	);
}
